module.exports = __webpack_public_path__ + "media/images/flags/32/Liechtenstein-d2b9cf3db509baab0df76d4e5582ba4a.png";